<template>
    <section>
        <titlebar :title-stack="titleStack"></titlebar>
        <div class="columns box">
            <div class="column is-5">
                <b-field>
                    <b-input :placeholder="$t('LOTECONTASPAGARLISTAR.PLACEHOLDERPROCURARPORNOME')"
                             v-model="procurar"
                             icon="magnify"
                             @input="loadAsyncData"></b-input>
                </b-field>
            </div>
            <div class="column">
                <div class="is-flex is-justified-between">
                    <router-link
                        v-if="isInRole('pagar-parcela-lote-alterar')"
                        :to="{ name: 'pagar-parcela-lote' }"
                        class="button is-primary"
                        >
                        {{$t('LOTECONTASPAGARLISTAR.INCLUIR')}}
                    </router-link>
                </div>                
            </div>           
            <div class="column is-2">
                <form @submit.prevent="abrirCadastroInput">
                    <b-field>
                        <b-input :placeholder="$t('LOTECONTASPAGARLISTAR.CODIGO')"
                                 v-model="id"
                                 type="text"
                                 icon-right="edit"
                                 icon-right-clickable
                                 @icon-right-click="abrirCadastroInput">
                        </b-input>
                    </b-field>
                </form>
            </div>
        </div>
        <b-table :data="model.lista"
                 :loading="loading"
                 paginated
                 striped
                 hoverable
                 backend-pagination
                 :total="total"
                 @page-change="onPageChange"
                  :aria-next-label="$t('LOTECONTASPAGARLISTAR.PROXPAGINA')"
                 :aria-previous-label="$t('LOTECONTASPAGARLISTAR.PAGANTERIOR')"
                 :aria-page-label="$t('LOTECONTASPAGARLISTAR.PAGINA')"
                 :aria-current-label="$t('LOTECONTASPAGARLISTAR.PAGATUAL')"
                 backend-sorting
                 :default-sort-direction="defaultOrdenar"
                 :default-sort="[ordenarPor, ordenar]"
                 sort-icon-size="is-small"
                 @sort="onSort">

            <template @click="abrirCadastro(props.row.id)">
                <b-table-column v-slot="props" field="id" :label="$t('LOTECONTASPAGARLISTAR.ID')">
                    {{ props.row.id }}
                </b-table-column>

                <b-table-column v-slot="props" field="Descricao" :label="$t('LOTECONTASPAGARLISTAR.DESCRICAO')">
                    {{ props.row.descricao }}
                </b-table-column>

                <b-table-column v-slot="props" field="ContaCorrente" :label="$t('LOTECONTASPAGARLISTAR.CONTACORRENTE')">
                    {{ props.row.contaCorrente }}
                </b-table-column>

                <b-table-column v-slot="props" field="DataInicial" :label="$t('LOTECONTASPAGARLISTAR.DATAINICIAL')">
                    {{ props.row.dataInicial != null ? $moment(props.row.dataInicial).format("DD/MM/YYYY") : "" }}
                </b-table-column>        

                <b-table-column v-slot="props" field="DataFinal" :label="$t('LOTECONTASPAGARLISTAR.DATAFINAL')">
                    {{ props.row.dataFinal != null ? $moment(props.row.dataFinal).format("DD/MM/YYYY") : "" }}
                </b-table-column>        

                <b-table-column v-slot="props" field="TipoDeBaixa" :label="$t('LOTECONTASPAGARLISTAR.TIPOBAIXA')">
                    {{ props.row.tipoDeBaixa }}
                </b-table-column>             

                <b-table-column v-slot="props" field="QtdeContas" :label="$t('LOTECONTASPAGARLISTAR.QTDCONTAS')">
                    {{ props.row.quantidade }}
                </b-table-column> 

                <b-table-column v-slot="props" field="Valor" :label="$t('LOTECONTASPAGARLISTAR.VALOR')">
                    {{ props.row.valor | currency}}
                </b-table-column>

                <b-table-column v-slot="props" field="" :label="$t('LOTECONTASPAGARLISTAR.PDF')">
                    <b-button icon-left="eye" class="is-success center"  @click.prevent.stop="download('LoteContasPagarPDF',props.row)"></b-button>
                </b-table-column>                                                                                                                      

                <b-table-column v-slot="props" custom-key="actions" numeric>
                    <router-link :to="{ name: 'pagar-parcela-lote', params: { id: props.row.id }}" class="button is-small is-primary" title="Editar">
                        <b-icon icon="pencil" size="is-small"></b-icon>
                    </router-link>
                </b-table-column>
            </template>
        </b-table>
    </section>
</template>

<style scoped>
.center {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    margin: 0 auto;
}
</style>

<script>
    import { mapGetters } from 'vuex'
    import titlebar from '@/components/titlebar.vue'

    export default {
        data() {
            return {
                model: [],
                total: 0,
                loading: false,
                procurar: this.$route.query.procurar ?? '',
                ordenarPor: 'Nome',
                ordenar: 'asc',
                defaultOrdenar: 'asc',
                page: 1,
                perPage: 20,
                selecionado: null,
                id: null
            }
        },
        components: {
            titlebar
        },
        computed: {
            titleStack() {
                return [
                    this.$t('SIDEBAR.FINANCEIRO'),
                    this.$t('LOTECONTASPAGARLISTAR.TITULO')
                ]
            },
            ...mapGetters([
                'isInRole'
            ])
        },
        methods: {
           loadAsyncData() {
                const params = [
                    `procurar=${this.procurar}`,
                    `ordem=${this.ordenarPor}.${this.ordenar}`,
                    `page=${this.page}`
                ].join('&')

                this.loading = true
                this.$http.get(`/api/financeiro/ListarPagarParcelaLote?${params}`)
                    .then(({ data }) => {
                        this.model = data;
                        if (data.lista.length == 0 && this.page > 1) {
                            this.page = 1
                            this.loadAsyncData()
                        }
                        this.total = this.perPage * data.pageCount
                        this.loading = false
                        this.$router.replace({query: {procurar: this.procurar, page: this.page }})
                    })
                    .catch((error) => {
                        this.model = []
                        this.total = 0
                        this.loading = false
                        throw error
                    })
            },
            onPageChange(page) {
                this.page = page
                this.loadAsyncData()
            },
            onSort(field, order) {
                this.ordenarPor = field
                this.ordenar = order
                this.loadAsyncData()
            },
            abrirCadastro() {
                this.$router.push({ path: `/financeiro/pagar-parcela-lote/${this.selecionado.id}` })
            },
            abrirCadastroInput() {
                this.$router.push({ path: `/financeiro/pagar-parcela-lote/${this.id}` })
            },
            download(itemName, item){
                window.open(`/api/financeiro/${itemName.toLowerCase()}?id=${item.id}`,'_blank');
            }
        },
        mounted() {
            this.loadAsyncData()
        }
    }
</script>